import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4iyz6j79hv: FaireBrandEntity = {
  token: "b_4iyz6j79hv",
  type: "brand",
  name: "The Earthling Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/971cbe2a88d25b3152c3afee61023aea87030cade995d2f85f814c25dc73f9b1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f76eaa1babb2e40fd702c44066b5fa973f390e6c4e6121660ffb54526dc7892c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/971cbe2a88d25b3152c3afee61023aea87030cade995d2f85f814c25dc73f9b1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f76eaa1babb2e40fd702c44066b5fa973f390e6c4e6121660ffb54526dc7892c.png",
  location: "Reno, NV, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 93,
  isTopShop: true,
  isInsider: true,
  description:
    'Emelia wanted what we all want: to look and feel good, with products she could trust. But as she looked deeper into conventional hair care, the truth was impossible to ignore—questionable ingredients, health risks, & mountains of plastic waste.\n\nFrustrated by so-called "clean" options that under delivered, she searched for something better: high-performance hair care made with safe, clean ingredients and zero plastic compromise.\n\nWhen she couldn\'t find it, she made it.\nAnd The Earthling Co. was born.',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.698Z",
    importedBy: "entity-db-cli",
  },
};
